export type ProviderSelectionMatch = {
  id: number;
  provider_reference?: string;
};

export const getProviderSelectionKey = (provider: ProviderSelectionMatch): string =>
  provider.provider_reference || String(provider.id);

const isLegacyNumericId = (value: string): boolean => /^\d+$/.test(value);

/** Match by provider_reference; numeric draft entries still match provider.id (legacy bridge). */
export const isProviderEntrySelected = (
  provider: ProviderSelectionMatch,
  selected: Array<string | number>,
): boolean =>
  selected.some((entry) => {
    const value = String(entry);
    const reference = provider.provider_reference;
    if (reference && value === reference) {
      return true;
    }
    return isLegacyNumericId(value) && value === String(provider.id);
  });
